'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tesselator = exports.polygon = undefined;

var _tesselator = require('./tesselator');

var tess = _interopRequireWildcard(_tesselator);

var _polygon = require('./polygon');

var p = _interopRequireWildcard(_polygon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var polygon = exports.polygon = p;
var tesselator = exports.tesselator = tess;

if (typeof window !== 'undefined') {
  window.PolygonTools = {
    polygon: p,
    tesselator: tess,
    version: window.polygon_tools_version || '',
    build: window.polygon_tools_rev || ''
  };
}